import { render } from "./Identification.vue?vue&type=template&id=75984f34"
import script from "./Identification.vue?vue&type=script&lang=js"
export * from "./Identification.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__